/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./changeCarrer.vue?vue&type=template&id=6cb34090&scoped=true&"
import script from "./changeCarrer.vue?vue&type=script&lang=js&"
export * from "./changeCarrer.vue?vue&type=script&lang=js&"
import style0 from "./changeCarrer.vue?vue&type=style&index=0&id=6cb34090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb34090",
  null
  
)

export default component.exports